module.exports = __webpack_public_path__ + "static/media/mmMusic.28e451e3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/music/mmMusic.mp3
// module id = 105
// module chunks = 0